// src/menu/menu-context.ts
import { createContext } from "react";
var MenuBarContext = createContext(
  void 0
);
var MenuContext = createContext(void 0);
var MenuItemCheckedContext = createContext(
  void 0
);

export {
  MenuBarContext,
  MenuContext,
  MenuItemCheckedContext
};
